export default {
  getActiveNavMenuItemId: state => state.activeNavMenuItemId,
  getStorageSpace: state => state.storageSpace,
  getSetupArchivePasswordStatus: state => state.setupArchivePasswordStatus,
  getContentItems: state => state.contentItems,
  getFetchStorageSpaceStatus: state => state.fetchStorageSpaceStatus,
  getFetchContentItemsStatus: state => state.fetchContentItemsStatus,
  getPostLoginOpenArchiveId: state => state.postLoginOpenArchiveId,
  getPostLoginOpenNavMenuId: state => state.postLoginOpenNavMenuId,
  getActiveContentType: state => state.activeContentType,
  getSharedContentItems: state => state.sharedContentItems,
  getFetchSharedContentItemsStatus: state => state.fetchSharedContentItemsStatus,
  getUserSubscription: state => state.userSubscription,
  getUserSubscriptionType: state => state.userSubscriptionType,
  getAppFeatures: state => state.appFeatures,
  getFileVersions: state => state.fileVersions,
  getFetchFileVersionsStatus: state => state.fetchFileVersionsStatus,
  getSharedLink: state => state.sharedLink,
  getCreateSharedLinkStatus: state => state.createSharedLinkStatus,
  getDeleteSharedLinkStatus: state => state.deleteSharedLinkStatus,
  getSharedLinkSettings: state => state.sharedLinkSettings,
  getFetchSharedLinkStatus: state => state.fetchSharedLinkStatus,
  getUpdateSharedLinkStatus: state => state.updateSharedLinkStatus,
  getSearchEnabled: state => state.searchEnabled,
  getBrandName: state => state.brandName,
  getSearchResultReceived: state => state.searchResultReceived,
  getActiveVersionPath: state => state.activeVersionPath,
  getActiveVolumePath: state => state.activeVolumePath,
  getActiveFolderItem: state => state.activeFolderItem,
  getSubAccountItems: state => state.subAccountItems,
  getVolumeSbMachines: state => state.volumeSbMachines,
  getFetchSubAccountItemsStatus: state => state.fetchSubAccountItemsStatus,
  getSubAccountArchives: state => state.subAccountArchives,
  getFetchSubAccountArchivesStatus: state => state.fetchSubAccountArchivesStatus,
  getActiveSubAccountDisplayName: state => state.activeSubAccountDisplayName,
  getActiveSubAccountId: state => state.activeSubAccountId,
  getActiveVolumeSbSubAccountId: state => state.activeVolumeSbSubAccountId,
  getActiveVolumeSubscription: state => state.activeVolumeSubscription,
  getCheckSubAccountStatus: state => state.checkSubAccountStatus
};
